/** Machine-readable codes returned in the `message` of public invite 404 responses. */
export enum InviteErrorCode {
  expired = 'invite-expired',
}
